import { WeightGridCriteria, WeightGridScenario, WeightGridWrapper } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';
import { ExternalAPI } from '../../model/external-api';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD, WIZ_COMMAND_STATE} from '@wizeoo/akm-core-lib';

/**
 * Commande REST de recherche des grilles de poids
 */
export class FindWeightGridCommand extends WizCommand<WeightGridWrapper> {

  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  
    const wrapper: WeightGridWrapper = new WeightGridWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    wrapper.scenario = new WeightGridScenario();
    wrapper.scenario.languageCode = this.model.currentLocaleCode;
    wrapper.criteria = new WeightGridCriteria();
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.scenario.manageKeys = true;
    wrapper.scenario.manageLines = true;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;

    this.configureRemote(ExternalAPI.WG_API, wrapper);

  }

  wizResult() {
    super.wizResult();
    if (this.state === WIZ_COMMAND_STATE.SUCCESS) {
      this.model.weightGridEngine.feedWeightGrids(this.result.entities);
    }
  }
}
